<template>
  <div class="def-insert-tilda" v-html="getHtmlStringWithoutScripts"></div>
</template>

<script>
export default {
  name: 'DefInsertTilda',
  props: ['result'],
  computed: {
    getHtmlStringWithoutScripts() {
      return this.result.replace(/<script[^>]*>([\S\s]*?)<\/script>/g, '');
    },
  },
  mounted() {
    try {
      this.executeScriptsFromHtml(this.result);
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    executeScriptsFromHtml(htmlString) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // Витягуємо всі <script>
      const scripts = tempDiv.querySelectorAll('script[src]');
      const scriptsInline = tempDiv.querySelectorAll('script:not([src])');

      const runInlineScripts = () => {
        scriptsInline.forEach((script) => {
          const newScript = document.createElement('script');

          // Якщо inline — вставляємо текст
          newScript.text = script.textContent;

          document.body.appendChild(newScript);
        });
      };

      scripts.forEach((script, key) => {
        const newScript = document.createElement('script');

        if (script.src) {
          // Якщо є src — підключаємо з URL
          newScript.src = script.src;
          newScript.async = false; // Зберігаємо порядок
          newScript.defer = true; // Зберігаємо порядок

          // після завантаження останього зовнішнього скрипта виконуємо інлайнові скрипти.
          if (key === scripts.length - 1) {
            newScript.onload = () => {
              runInlineScripts();
            };
          }
        }

        document.body.appendChild(newScript);
      });
    },
    /**
     * create DOM elements from string
     * @param data
     * @returns {*}
     */
    createHtmlFromString(data) {
      try {
        let htmlString = data;
        htmlString = data.replace(/\$\(document\)\.ready\(/g, '$(window).on("load",');
        htmlString = data.replace(/\$\(window\)\.load\(/g, '$(window).on("load",');
        htmlString = `<div>${htmlString}</div>`;

        return document.createRange().createContextualFragment(htmlString);
      } catch (err) {
        console.error(err);
        return data;
      }
    },
    /**
     * insert html in page
     * @param html
     */
    appendHtml(html) {
      try {
        this.$el.appendChild(html);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-insert-tilda {
  :deep(*),
  :deep(*:after),
  :deep(*:before) {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }
  :deep(img) {
    display: inline-block;
  }
  :deep {
    .t-btn {
      box-sizing: border-box;
    }
    .t-col {
      @media screen and (max-width: 960px) {
        box-sizing: border-box;
      }
    }
  }
}
</style>
